import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/app/[lang]/(main)/companies/[id]/SingleCompanyClient.tsx");
